/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
    //home
    {
        path: '',
        name: 'Home',
        view: 'Home'
    },
    //account
    {
        path: '/account',
        name: 'Account',
        view: 'Account'
    },
    //privacy-policy
    {
        path: '/privacy-policy',
        name: 'Privacy',
        view: 'Privacy'
    },
    //cart
    {
        path: '/cart',
        name: 'Cart',
        view: 'Cart'
    },
    //about
    {
        path: '/about',
        name: 'About',
        view: 'About'
    },
    //thanks
    {
        path: '/thanks/:order',
        name: 'Thanks',
        view: 'Thanks'
    },
    //search
    {
        path: '/search',
        name: 'Search',
        view: 'Search'
    },
    //reset
    {
        path: '/reset',
        name: 'Reset',
        view: 'Reset'
    },
    //reset
    {
        path: '/contact',
        name: 'Contact',
        view: 'Contact'
    },
    //products or categories
    {
        path: '/:urlPage',
        name: 'Product',
        view: 'Page'
    },
]
